// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"cb508b66","248":"006562ec","382":"f1c159a1","472":"919f96b3","618":"6216be11","642":"9cb08640","653":"a8de7474","732":"3f50783c","760":"6b1eb940"}[chunkId] + ".chunk.css";
};